export default __webpack_public_path__ + "static/media/deliland-liggies-icon.32907d3c.png";